/* generated by Svelte v3.31.0 */
import { SvelteComponent, binding_callbacks, create_slot, detach, element, init, insert, safe_not_equal, set_custom_element_data, transition_in, transition_out, update_slot } from "svelte/internal";
import { define } from "../lib";
import { VmDefaultUi, VmCaptionControl, VmControl, VmIcon, VmTooltip, VmCaptions, VmClickToPlay, VmControlGroup, VmControlSpacer, VmControls, VmCurrentTime, VmTime, VmDblClickFullscreen, VmDefaultControls, VmEndTime, VmFullscreenControl, VmLiveIndicator, VmMuteControl, VmPipControl, VmPlaybackControl, VmScrim, VmScrubberControl, VmSlider, VmSettingsControl, VmTimeProgress, VmVolumeControl, VmDefaultSettings, VmMenu, VmMenuItem, VmMenuRadio, VmMenuRadioGroup, VmSettings, VmSubmenu, VmLoadingScreen, VmPoster, VmSpinner, VmUi } from "@vime/core";
import { createEventDispatcher, onMount } from "svelte";
function create_fragment(ctx) {
    let vm_default_ui;
    let current;
    const default_slot_template = /*#slots*/ ctx[14].default;
    const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[13], null);
    return {
        c() {
            vm_default_ui = element("vm-default-ui");
            if (default_slot)
                default_slot.c();
            set_custom_element_data(vm_default_ui, "class", /*className*/ ctx[0]);
            set_custom_element_data(vm_default_ui, "style", /*style*/ ctx[1]);
            set_custom_element_data(vm_default_ui, "no-click-to-play", /*noClickToPlay*/ ctx[2]);
            set_custom_element_data(vm_default_ui, "no-dbl-click-fullscreen", /*noDblClickFullscreen*/ ctx[3]);
            set_custom_element_data(vm_default_ui, "no-captions", /*noCaptions*/ ctx[4]);
            set_custom_element_data(vm_default_ui, "no-poster", /*noPoster*/ ctx[5]);
            set_custom_element_data(vm_default_ui, "no-spinner", /*noSpinner*/ ctx[6]);
            set_custom_element_data(vm_default_ui, "no-controls", /*noControls*/ ctx[7]);
            set_custom_element_data(vm_default_ui, "no-settings", /*noSettings*/ ctx[8]);
            set_custom_element_data(vm_default_ui, "no-loading-screen", /*noLoadingScreen*/ ctx[9]);
        },
        m(target, anchor) {
            insert(target, vm_default_ui, anchor);
            if (default_slot) {
                default_slot.m(vm_default_ui, null);
            }
            /*vm_default_ui_binding*/ ctx[15](vm_default_ui);
            current = true;
        },
        p(ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && dirty & /*$$scope*/ 8192) {
                    update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[13], dirty, null, null);
                }
            }
            if (!current || dirty & /*className*/ 1) {
                set_custom_element_data(vm_default_ui, "class", /*className*/ ctx[0]);
            }
            if (!current || dirty & /*style*/ 2) {
                set_custom_element_data(vm_default_ui, "style", /*style*/ ctx[1]);
            }
            if (!current || dirty & /*noClickToPlay*/ 4) {
                set_custom_element_data(vm_default_ui, "no-click-to-play", /*noClickToPlay*/ ctx[2]);
            }
            if (!current || dirty & /*noDblClickFullscreen*/ 8) {
                set_custom_element_data(vm_default_ui, "no-dbl-click-fullscreen", /*noDblClickFullscreen*/ ctx[3]);
            }
            if (!current || dirty & /*noCaptions*/ 16) {
                set_custom_element_data(vm_default_ui, "no-captions", /*noCaptions*/ ctx[4]);
            }
            if (!current || dirty & /*noPoster*/ 32) {
                set_custom_element_data(vm_default_ui, "no-poster", /*noPoster*/ ctx[5]);
            }
            if (!current || dirty & /*noSpinner*/ 64) {
                set_custom_element_data(vm_default_ui, "no-spinner", /*noSpinner*/ ctx[6]);
            }
            if (!current || dirty & /*noControls*/ 128) {
                set_custom_element_data(vm_default_ui, "no-controls", /*noControls*/ ctx[7]);
            }
            if (!current || dirty & /*noSettings*/ 256) {
                set_custom_element_data(vm_default_ui, "no-settings", /*noSettings*/ ctx[8]);
            }
            if (!current || dirty & /*noLoadingScreen*/ 512) {
                set_custom_element_data(vm_default_ui, "no-loading-screen", /*noLoadingScreen*/ ctx[9]);
            }
        },
        i(local) {
            if (current)
                return;
            transition_in(default_slot, local);
            current = true;
        },
        o(local) {
            transition_out(default_slot, local);
            current = false;
        },
        d(detaching) {
            if (detaching)
                detach(vm_default_ui);
            if (default_slot)
                default_slot.d(detaching);
            /*vm_default_ui_binding*/ ctx[15](null);
        }
    };
}
define("vm-default-ui", VmDefaultUi);
define("vm-caption-control", VmCaptionControl);
define("vm-control", VmControl);
define("vm-icon", VmIcon);
define("vm-tooltip", VmTooltip);
define("vm-captions", VmCaptions);
define("vm-click-to-play", VmClickToPlay);
define("vm-control-group", VmControlGroup);
define("vm-control-spacer", VmControlSpacer);
define("vm-controls", VmControls);
define("vm-current-time", VmCurrentTime);
define("vm-time", VmTime);
define("vm-dbl-click-fullscreen", VmDblClickFullscreen);
define("vm-default-controls", VmDefaultControls);
define("vm-end-time", VmEndTime);
define("vm-fullscreen-control", VmFullscreenControl);
define("vm-live-indicator", VmLiveIndicator);
define("vm-mute-control", VmMuteControl);
define("vm-pip-control", VmPipControl);
define("vm-playback-control", VmPlaybackControl);
define("vm-scrim", VmScrim);
define("vm-scrubber-control", VmScrubberControl);
define("vm-slider", VmSlider);
define("vm-settings-control", VmSettingsControl);
define("vm-time-progress", VmTimeProgress);
define("vm-volume-control", VmVolumeControl);
define("vm-default-settings", VmDefaultSettings);
define("vm-menu", VmMenu);
define("vm-menu-item", VmMenuItem);
define("vm-menu-radio", VmMenuRadio);
define("vm-menu-radio-group", VmMenuRadioGroup);
define("vm-settings", VmSettings);
define("vm-submenu", VmSubmenu);
define("vm-loading-screen", VmLoadingScreen);
define("vm-poster", VmPoster);
define("vm-spinner", VmSpinner);
define("vm-ui", VmUi);
function instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope } = $$props;
    let __ref;
    let __mounted = false;
    const dispatch = createEventDispatcher();
    let { class: className } = $$props;
    let { style } = $$props;
    let { noClickToPlay = false } = $$props;
    let { noDblClickFullscreen = false } = $$props;
    let { noCaptions = false } = $$props;
    let { noPoster = false } = $$props;
    let { noSpinner = false } = $$props;
    let { noControls = false } = $$props;
    let { noSettings = false } = $$props;
    let { noLoadingScreen = false } = $$props;
    const ref = () => __ref;
    const getWebComponent = () => __ref;
    onMount(() => {
        __mounted = true;
    });
    const onEvent = e => {
        e.stopPropagation();
        dispatch(e.type, e.detail);
    };
    function vm_default_ui_binding($$value) {
        binding_callbacks[$$value ? "unshift" : "push"](() => {
            __ref = $$value;
            $$invalidate(10, __ref);
        });
    }
    $$self.$$set = $$props => {
        if ("class" in $$props)
            $$invalidate(0, className = $$props.class);
        if ("style" in $$props)
            $$invalidate(1, style = $$props.style);
        if ("noClickToPlay" in $$props)
            $$invalidate(2, noClickToPlay = $$props.noClickToPlay);
        if ("noDblClickFullscreen" in $$props)
            $$invalidate(3, noDblClickFullscreen = $$props.noDblClickFullscreen);
        if ("noCaptions" in $$props)
            $$invalidate(4, noCaptions = $$props.noCaptions);
        if ("noPoster" in $$props)
            $$invalidate(5, noPoster = $$props.noPoster);
        if ("noSpinner" in $$props)
            $$invalidate(6, noSpinner = $$props.noSpinner);
        if ("noControls" in $$props)
            $$invalidate(7, noControls = $$props.noControls);
        if ("noSettings" in $$props)
            $$invalidate(8, noSettings = $$props.noSettings);
        if ("noLoadingScreen" in $$props)
            $$invalidate(9, noLoadingScreen = $$props.noLoadingScreen);
        if ("$$scope" in $$props)
            $$invalidate(13, $$scope = $$props.$$scope);
    };
    return [
        className,
        style,
        noClickToPlay,
        noDblClickFullscreen,
        noCaptions,
        noPoster,
        noSpinner,
        noControls,
        noSettings,
        noLoadingScreen,
        __ref,
        ref,
        getWebComponent,
        $$scope,
        slots,
        vm_default_ui_binding
    ];
}
class DefaultUi extends SvelteComponent {
    constructor(options) {
        super();
        init(this, options, instance, create_fragment, safe_not_equal, {
            class: 0,
            style: 1,
            noClickToPlay: 2,
            noDblClickFullscreen: 3,
            noCaptions: 4,
            noPoster: 5,
            noSpinner: 6,
            noControls: 7,
            noSettings: 8,
            noLoadingScreen: 9,
            ref: 11,
            getWebComponent: 12
        });
    }
    $on(type, callback) {
        return super.$on(type, callback);
    }
    $set($$props) {
        super.$set($$props);
    }
    get ref() {
        return this.$$.ctx[11];
    }
    get getWebComponent() {
        return this.$$.ctx[12];
    }
}
export default DefaultUi;
//# sourceMappingURL=DefaultUi.js.map